import React from 'react';
import Count from 'react-countdown';
import { useParams } from 'react-router-dom';
import { useRequest } from 'hooks';

import DayJs from 'utils/Dayjs';
import Pill from 'components/Misc/Pill';

import { useExamStudentStore } from 'store/exam/useExamStudentStore';

const Countdown = () => {
	// Store current take id
	const { id } = useParams();

	// Use exam's student store
	const [state, startedAt, duration, answers, onEnd] = useExamStudentStore(state => [
		state.take.state,
		state.take.startedAt,
		state.exam.duration,
		state.answers,
		state.onEnd
	]);

	// Store update request
	const [[progress], request] = useRequest('put', `takes/${id}`);

	// Handle countdown render
	const renderer = ({ days, hours, minutes, seconds, total }) => {
		return <Pill
			name={`${days}d : ${hours}h : ${minutes}m : ${seconds}s`}
			theme={total <= 300000 ? 'danger' : 'informative'}
			className="ml-4"
		/>;
	};

	// Handle take's end
	const onComplete = async () => {
		// Do not submit twice
		if (progress) return;

		// Do not submit non active take
		if (state !== 'active') return;

		// Try to end exam
		const [success, error] = await request(answers, { action: 'end' });

		// Handle takes ending
		if (success) {
			return onEnd({
				state: success.state,
				endedAt: success.endedAt
			});
		}

		// Handle take's ending
		if (error?.message === 'takeHasEnded') {
			return onEnd({
				state: 'finished'
			});
		}
	};
	
	return (
		<Count
			renderer={renderer}
			onComplete={onComplete}
			date={DayJs(startedAt).add(duration, 'm').toISOString()}
		/>
	);
};

export default Countdown;